import { QueryClient } from "@tanstack/react-query";

/**
 * Factory function for creating the TanStack Query client.
 * Centralizes all default query/mutation options.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000, // 30 seconds before data is stale
        gcTime: 5 * 60_000, // 5 minutes garbage collection
        retry: 2, // Retry failed queries twice
        retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 10_000),
        refetchOnWindowFocus: true,
      },
      mutations: {
        retry: 0, // Do not retry mutations
      },
    },
  });
}
